module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-form-table', {
    staticClass: "product-table",
    attrs: {
      "form": _vm.form,
      "list": _vm.prices,
      "create": _vm.save,
      "update": _vm.update,
      "destroy": _vm.destroy,
      "translation": "table.products",
      "clickHandler": _vm.tableClickHandler
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bc5a135","hasScoped":false}!./src/app/components/productPriceTable/productPriceTable.html
// module id = 2950
// module chunks = 1